<ng-container *ngIf="showLogo">
  <a *ngIf="hasLink; else logo" class="logo__link">
    <ng-template *ngTemplateOutlet="logo"></ng-template>
  </a>
</ng-container>

<ng-template #logo>
  <img
    class="logo__image"
    [src]="logoSrc"
    alt="Logo"
    [attr.data-e2e]="e2e + '__product-logo--img'"
  />
</ng-template>
